import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function ProblemSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].problem;
  return <section className="py-12 md:py-20 px-4 bg-gradient-to-b from-teal-950 to-black" data-id="element-288">
      <div className="max-w-4xl mx-auto" data-id="element-289">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6 md:mb-8 text-red-400" data-id="element-290">
          {t.title}
        </h2>
        <p className="text-xl md:text-2xl text-center mb-8 md:mb-12 text-teal-100" data-id="element-291">
          {t.subtitle}
        </p>
        <div className="bg-gradient-to-br from-red-950/30 to-black border border-red-900/30 rounded-2xl p-6 md:p-12" data-id="element-292">
          <p className="text-lg md:text-xl mb-4 md:mb-6 text-red-300 font-semibold" data-id="element-293">
            {t.intro}
          </p>
          <div className="space-y-3 md:space-y-4" data-id="element-294">
            {t.problems.map((problem, index) => <div key={index} className="flex items-start gap-3 md:gap-4" data-id="element-295">
                <XCircleIcon className="w-5 h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-296" />
                <p className="text-base md:text-lg text-gray-300" data-id="element-297">{problem}</p>
              </div>)}
          </div>
          <div className="mt-6 md:mt-10 p-4 md:p-6 bg-red-950/50 border border-red-800/30 rounded-xl" data-id="element-298">
            <p className="text-base md:text-lg leading-relaxed text-gray-200" data-id="element-299">
              {t.conclusion}{' '}
              <span className="text-red-400 font-semibold" data-id="element-300">{t.system}</span>{' '}
              {language === 'en' ? 'while your soul keeps whispering,' : 'mientras tu alma sigue susurrando,'}{' '}
              <span className="text-yellow-400 italic" data-id="element-301">{t.soul}</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}